<template>
  <Form ref="chargeRuleForm" :model="chargeRule" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="chargeRule.id" type="hidden"/>

    <FormItem  :label="this.$t('travel.charge-rule.ruleName.label')" prop="ruleName">
      <Input v-model="chargeRule.ruleName" :placeholder="$t('travel.charge-rule.ruleName.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('travel.charge-rule.ruleCode.label')" prop="ruleCode">
      <Input v-model="chargeRule.ruleCode" :placeholder="$t('travel.charge-rule.ruleCode.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('travel.charge-rule.ruleType.label')" prop="ruleType">
      <Select v-model="chargeRule.ruleType" :placeholder="$t('travel.charge-rule.ruleType.holder')"
              @on-change="handleChangeSelect">
        <Option v-for="item in this.dict.rule_type" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>
    <div>
      <FormItem  :label="`免费停车时长`" prop="ruleDetailCommon">
        <Input v-model="ruleDetailCommon.freeTime" :placeholder="`请输入免费停车时长`"  type="text"/>
      </FormItem>
      <FormItem  :label="`最高收费`" prop="ruleDetailCommon">
        <Input v-model="ruleDetailCommon.maxFee" :placeholder="`请输入最高收费`"  type="text"/>
      </FormItem>
      <FormItem  :label="`最高收费开关`" prop="ruleDetailCommon">
        <!--<Input v-model="chargeRule.ruleDetail.maxFee" :placeholder="`请最高收费开关`"  type="text" style="width:150px;margin-right: 10px;"/>-->
        <Select v-model="ruleDetailCommon.maxFlag"  placeholder="请选择封顶开关">
          <Option
            value="true"
          >
            是
          </Option>
          <Option
            value="false"
          >
            否
          </Option>
        </Select>
      </FormItem>
    </div>
    <div v-for="(item,index1) in ruleDetail0" :key="index1">
      <div v-if="chargeRule.ruleType==0" style="display: flex;flex-wrap: wrap;justify-content: space-around">
        <FormItem  :label="`开始时间`" prop="ruleDetail0">
          <Input v-model="item.startTime" :placeholder="`请输入开始时间`"  type="text" style="width:150px;margin-right: 10px;"/>
        </FormItem>
        <FormItem  :label="`结束时间`" prop="ruleDetail0">
          <Input v-model="item.endTime" :placeholder="`请输入结束时间`"  type="text" style="width:150px;margin-right: 10px;"/>
        </FormItem>
        <FormItem  :label="`单位时长`" prop="ruleDetail0">
          <Input v-model="item.costUnit" :placeholder="`请输入单位时长`"  type="text" style="width:150px;margin-right: 10px;"/>
        </FormItem>
        <FormItem  :label="`时间段费用`" prop="ruleDetail0">
          <Input v-model="item.fee" :placeholder="`请输入时间段费用`"  type="text" style="width:150px;margin-right: 10px;"/>
        </FormItem>
        <FormItem  :label="`最小跨度时间`" prop="ruleDetail0">
          <Input v-model="item.minInterval" :placeholder="`请输入最小跨度时间`"  type="text" style="width:150px;margin-right: 10px;"/>
        </FormItem>
        <FormItem>
          <Input  type="hidden" style="width:150px;margin-right: 10px;"/>
        </FormItem>
        <Button @click="addForm()" type="primary" >添加规则</Button>
        <Button v-if="index1!=0" @click="removeIdx(item, index1)" type="error" >删除规则</Button>
      </div>
    </div>
     <!--<div v-if="chargeRule.ruleType==1">-->
       <div v-for="(item,index2) in ruleDetail1" :key="index2">
          <div v-if="chargeRule.ruleType==1" style="display: flex;flex-wrap: wrap;justify-content: space-around">
            <FormItem  :label="`开始时间`" prop="ruleDetail1">
              <Input v-model="item.startTime" :placeholder="`请输入开始时间`"  type="text" style="width:150px;margin-right: 10px;"/>
            </FormItem>
            <FormItem  :label="`结束时间`" prop="ruleDetail1">
              <Input v-model="item.endTime" :placeholder="`请输入结束时间`"  type="text" style="width:150px;margin-right: 10px;"/>
            </FormItem>
            <FormItem  :label="`应收金额`" prop="ruleDetail1">
              <Input v-model="item.inFee" :placeholder="`请输入应收金额`"  type="text" style="width:150px;margin-right: 10px;"/>
            </FormItem>
            <FormItem>
              <Input  type="hidden" style="width:150px;margin-right: 10px;"/>
            </FormItem>
              <Button @click="addForm()" type="primary" >添加规则</Button>
              <Button v-if="index2!=0" @click="removeIdx(item, index2)" type="error" >删除规则</Button>
          </div>
       </div>
     <!--</div>-->
     <div v-if="chargeRule.ruleType==2" style="display: flex;flex-wrap: wrap;">
       <FormItem  :label="`单次收费`" prop="ruleDetail2">
         <Input v-model="ruleDetail2.onceFee" :placeholder="`请输入单次收费`"  type="text" style="width:150px;margin-right: 10px;"/>
       </FormItem>
       <FormItem  :label="`是否允许跨天`" prop="ruleDetail2">
         <Select v-model="ruleDetail2.isCrossDay" style="width:150px;margin-right: 10px;" placeholder="请选择是否允许跨天">
           <Option
             value="true"
           >
             是
           </Option>
           <Option
             value="false"
           >
             否
           </Option>
         </Select>
       </FormItem>
     </div>

    <div v-if="chargeRule.ruleType==3" style="display: flex;flex-wrap: wrap;">
      <FormItem  :label="`白天开始时间`" prop="ruleDetail3">
        <Input v-model="ruleDetail3.dayStartTime" :placeholder="`请输入白天开始时间`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
      <FormItem  :label="`夜晚开始时间`" prop="ruleDetail3">
        <Input v-model="ruleDetail3.nightStartTime" :placeholder="`请输入夜晚开始时间`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
      <FormItem  :label="`白天时间间隔时长`" prop="ruleDetail3">
        <Input v-model="ruleDetail3.dayIntervalTime" :placeholder="`请输入白天时间间隔时长`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
      <FormItem  :label="`白天间隔费用`" prop="ruleDetail3">
        <Input v-model="ruleDetail3.dayIntervalFee" :placeholder="`请输入白天间隔费用`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
      <FormItem  :label="`最小跨度时间`" prop="ruleDetail3">
        <Input v-model="ruleDetail3.minInterval" :placeholder="`请输入最小跨度时间`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
      <FormItem  :label="`夜间收费时长`" prop="ruleDetail3">
        <Input v-model="ruleDetail3.nightFeeTime" :placeholder="`请输入夜间收费时长`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
      <FormItem  :label="`夜间费用`" prop="ruleDetail3">
        <Input v-model="ruleDetail3.nightFee" :placeholder="`请输入夜间收费费用`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
    </div>

    <div v-if="chargeRule.ruleType==4" style="display: flex;flex-wrap: wrap;">
      <FormItem  :label="`首段收费时长`" prop="ruleDetail4">
        <Input v-model="ruleDetail4.firstTime" :placeholder="`请输入首段收费时长`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
      <FormItem  :label="`首段收费金额`" prop="ruleDetail4">
        <Input v-model="ruleDetail4.firstFee" :placeholder="`请输入首段收费金额`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
      <FormItem  :label="`间隔收费时长`" prop="ruleDetail4">
        <Input v-model="ruleDetail4.intervalTime" :placeholder="`请输入间隔收费时长`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
      <FormItem  :label="`间隔收费金额`" prop="ruleDetail4">
        <Input v-model="ruleDetail4.intervalFee" :placeholder="`请输入间隔收费金额`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
      <FormItem  :label="`最小跨度时间`" prop="ruleDetail4">
        <Input v-model="ruleDetail4.minInterval" :placeholder="`请输入最小跨度时间`"  type="text" style="width:150px;margin-right: 10px;"/>
      </FormItem>
    </div>
    <!--<FormItem  :label="this.$t('travel.charge-rule.ruleDetail.label')" >
      <Input v-model="chargeRule.ruleDetail" :placeholder="$t('travel.charge-rule.ruleDetail.holder')"  type="textarea" :rows="3"/>
    </FormItem>-->

<!--    <FormItem  :label="this.$t('travel.charge-rule.dayMaxFee.label')" prop="dayMaxFee">-->
<!--      <InputNumber v-model="chargeRule.dayMaxFee" :placeholder="$t('travel.charge-rule.dayMaxFee.holder')"/>-->
<!--    </FormItem>-->

<!--    <FormItem  :label="this.$t('travel.charge-rule.dayMaxStatus.label')" prop="dayMaxStatus">-->
<!--      <InputNumber v-model="chargeRule.dayMaxStatus" :placeholder="$t('travel.charge-rule.dayMaxStatus.holder')"/>-->
<!--    </FormItem>-->

    <FormItem  :label="this.$t('travel.charge-rule.carType.label')" prop="carType">
      <Select v-model="chargeRule.carType" :placeholder="$t('travel.charge-rule.carType.holder')">
        <Option v-for="item in this.dict.car_type" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
      </Select>
    </FormItem>
  </Form>
</template>
<script>
import api from '@/api'

export default {
  dictParams: ['rule_type','car_type'],
  data () {
    return {
      chargeRule: {
        id: null,
        ruleName: null,
        ruleCode: null,
        ruleDetail: null,
        ruleType: null,
        dayMaxFee: null,
        dayMaxStatus: 0,
        carType: 0
      },
      ruleDetailCommon: {
        maxFee: '',
        freeTime: '',
        maxFlag: '',
        periodDTOList: undefined,
        timeDTOList: undefined
      },
      ruleDetail0: [
        {
          startTime: '',
          endTime: '',
          costUnit: '',
          fee: '',
          minInterval: '',

        }
      ],
      ruleDetail1: [
        {
        startTime: '',
        endTime: '',
        inFee: ''
      }
      ],
      ruleDetail2:{
        onceFee: '',
        isCrossDay: ''
      },

      ruleDetail3:{
        dayStartTime: '',
        nightStartTime: '',
        dayIntervalTime: '',
        dayIntervalFee: '',
        minInterval: '',
        nightFeeTime: '',
        nightFee: ''
      },
      ruleDetail4:{
        firstTime: '',
        firstFee: '',
        intervalTime: '',
        intervalFee: '',
        minInterval: ''
      },
      flag:{
        1:true,
        0:false
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['chargeRuleForm'].validate(valid => {
        let ruleDetailStr = "0";
        console.log(this.chargeRule.ruleType)
        switch (this.chargeRule.ruleType){
          case 0:
            this.ruleDetailCommon.timeDTOList=this.ruleDetail0;
            ruleDetailStr = JSON.stringify(this.ruleDetailCommon);
            break;
          case 1:
            this.ruleDetailCommon.periodDTOList=this.ruleDetail1;
            ruleDetailStr = JSON.stringify(this.ruleDetailCommon);
            break;
          case 2:
            ruleDetailStr = JSON.stringify(Object.assign(this.ruleDetailCommon,this.ruleDetail2));
            break;
          case 3:
            ruleDetailStr = JSON.stringify(Object.assign(this.ruleDetailCommon,this.ruleDetail3));
            break;
          case 4:
            ruleDetailStr = JSON.stringify(Object.assign(this.ruleDetailCommon,this.ruleDetail4));
            break;
          default:
            console.log(1);
        }
        console.log("=================")
        console.log(ruleDetailStr);
       // console.log(JSON.parse(ruleDetailStr));
        this.chargeRule.ruleDetail=ruleDetailStr;
        if (valid) {
          if (this.chargeRule.id) {
            this.updateChargeRule(this.chargeRule).then(then).error(error)
          } else {
            this.createChargeRule(this.chargeRule).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleChangeSelect(){
      this.ruleDetailCommon={
        maxFee: '',
        freeTime: '',
        maxFlag: ''
      }
      this.ruleDetail0=[
          {
            startTime: '',
            endTime: '',
            costUnit: '',
            fee: '',
            minInterval: ''
          }
        ];
      this.ruleDetail1=[
          {
            startTime: '',
            endTime: '',
            inFee: ''
          }
        ]
      this.ruleDetail2={
        onceFee: '',
        isCrossDay: ''
      };
      this.ruleDetail3={
        dayStartTime: '',
        nightStartTime: '',
        dayIntervalTime: '',
        dayIntervalFee: '',
        minInterval: '',
        nightFeeTime: '',
        nightFee: ''
      }
      this.ruleDetail4={
        firstTime: '',
        firstFee: '',
        intervalTime: '',
        intervalFee: '',
        minInterval: ''
      }
    },
    handleReset(){
      this.chargeRule.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['chargeRuleForm'].resetFields());
    },
    getChargeRule(id,type){
      this.loading = true;
      this.$refs['chargeRuleForm'].resetFields()
      api.travel.ChargeRule.detail(id).then(data => {
        //console.log(data);
        //this.chargeRule = data;
        console.log(data.ruleDetail);
        var ruleDetailJson = JSON.parse(data.ruleDetail);

        //var ruleDetaileArrayper = JSON.parse(ruleDetailJson.periodDTOList);
        console.log("========================");
        console.log(ruleDetailJson);
        console.log(ruleDetailJson.periodDTOList);
        console.log("========================");

        this.ruleDetail0 = ruleDetailJson.timeDTOList;
        this.ruleDetail1 = ruleDetailJson.periodDTOList;

        this.ruleDetailCommon.freeTime = ruleDetailJson.freeTime;
        this.ruleDetailCommon.maxFee = ruleDetailJson.maxFee;
        this.ruleDetailCommon.maxFlag = ruleDetailJson.maxFlag;

        this.ruleDetail2.isCrossDay = ruleDetailJson.isCrossDay;
        this.ruleDetail2.onceFee = ruleDetailJson.onceFee;

        this.ruleDetail3.nightFee = ruleDetailJson.nightFee;
        this.ruleDetail3.nightFeeTime = ruleDetailJson.nightFeeTime;
        this.ruleDetail3.minInterval = ruleDetailJson.minInterval
        this.ruleDetail3.dayIntervalFee = ruleDetailJson.dayIntervalFee;
        this.ruleDetail3.dayIntervalTime = ruleDetailJson.dayIntervalTime
        this.ruleDetail3.nightStartTime = ruleDetailJson.nightStartTime;
        this.ruleDetail3.dayStartTime = ruleDetailJson.dayStartTime;

        this.ruleDetail4.firstFee = ruleDetailJson.freeTime;
        this.ruleDetail4.firstTime = ruleDetailJson.firstTime;
        this.ruleDetail4.intervalFee = ruleDetailJson.intervalFee;
        this.ruleDetail4.intervalTime = ruleDetailJson.intervalTime;
        this.ruleDetail4.minInterval = ruleDetailJson.minInterval;

        this.chargeRule.id = data.id;
        this.chargeRule.ruleName = data.ruleName;
        this.chargeRule.ruleCode = data.ruleCode;
        this.chargeRule.carType = data.carType;
        this.chargeRule.dayMaxFee = data.dayMaxFee;
        this.chargeRule.ruleDetail = data.ruleDetail;
        this.chargeRule.ruleType = data.ruleType;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createChargeRule(chargeRule){
      this.loading = true;
      return api.travel.ChargeRule.add(chargeRule)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    addForm() {
      // 定义一个标识，通过标识判断是否能添加信息
      let statusType = true;
      if (this.chargeRule.ruleType==1){
        this.ruleDetail1.forEach((item) => {
          if (item.startTime == "" || item.endTime == "" || item.inFee == ""
          ) {
            this.$Message.info('请完善信息后在添加');
            statusType = false;
          }
        });
        if (statusType) {
          this.ruleDetail1.push({
            startTime: "",
            endTime: "",
            inFee: "",
          });
        }
      }
      if (this.chargeRule.ruleType==0){
        this.ruleDetail0.forEach((item) => {
          if (item.startTime == "" || item.endTime == "" ||
            item.costUnit=="" || item.fee == ""
          ) {
            this.$Message.info('请完善信息后在添加');
            statusType = false;
          }
        });
        if (statusType) {
          this.ruleDetail0.push({
            startTime: "",
            endTime: "",
            costUnit: "",
            fee: "",
            minInterval: ""
          });
        }
      }
    },
    removeIdx(item, index) {
      if (this.chargeRule.ruleType==1){
        this.ruleDetail1.splice(index, 1);
        this.$Message.info('删除信息成功');
      }
      if (this.chargeRule.ruleType==0){
        this.ruleDetail0.splice(index, 1);
        this.$Message.info('删除信息成功');
      }
    },
    updateChargeRule(chargeRule){
      this.loading = true;
      return api.travel.ChargeRule.update(chargeRule)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      ruleName: [{type: 'string', required: true, message: this.$t('travel.charge-rule.ruleName.required'),trigger: 'blur'}, {type: 'string',max: 20, message: this.$t('travel.charge-rule.ruleName.max'),trigger: 'blur'}],
      ruleCode: [{type: 'string', required: true, message: this.$t('travel.charge-rule.ruleCode.required'),trigger: 'blur'}, {type: 'string',max: 20, message: this.$t('travel.charge-rule.ruleCode.max'),trigger: 'blur'}],
      //ruleType: [{required: true, message: this.$t('travel.charge-rule.ruleType.required'),trigger: 'blur'}],
      //ruleDetail: [{type: 'string', required: true, message: this.$t('travel.charge-rule.ruleDetail.required'),trigger: 'blur'}, {type: 'string',max: 4096, message: this.$t('travel.charge-rule.ruleDetail.max'),trigger: 'blur'}],
      // dayMaxFee: [{type: 'number', required: true, message: this.$t('travel.charge-rule.dayMaxFee.required'),trigger: 'blur'}],
      // dayMaxStatus: [{type: 'number', required: true, message: this.$t('travel.charge-rule.dayMaxStatus.required'),trigger: 'blur'}],
      carType: [{type: 'number', required: true, message: this.$t('travel.charge-rule.carType.required'),trigger: 'blur'}],
      createTime: [{type: 'date', required: true, message: this.$t('travel.charge-rule.createTime.required'),trigger: 'blur'}],
      updateTime: [{type: 'date', required: true, message: this.$t('travel.charge-rule.updateTime.required'),trigger: 'blur'}],
      isDelete: [{type: 'number', required: true, message: this.$t('travel.charge-rule.isDelete.required'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['chargeRuleForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
